const normalizePath = (path: string) => path.replace(/^\/+/, "").replace(/\/+$/, "")

const ensureTrailingSlash = (path: string) => (path.endsWith("/") ? path : `${path}/`)

const buildFullPath = (base: string, name: string) => `${ensureTrailingSlash(base)}${name}`

export interface BunnyEntry {
  name: string
  fullPath: string
}

export async function listFolder(path: string): Promise<BunnyEntry[]> {
  const normalizedPath = normalizePath(path)
  const folderPath = ensureTrailingSlash(normalizedPath)
  const functionBase = import.meta.env.VITE_FUNCTIONS_BASE || "/.netlify/functions"
  const requestUrl = `${functionBase.replace(/\/+$/, "")}/bunny-list?path=${encodeURIComponent(folderPath)}`

  const response = await fetch(requestUrl, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to list Bunny folder ${normalizedPath}: ${response.status} ${response.statusText}`)
  }

  const rawText = await response.text()
  const entries: BunnyEntry[] = []

  try {
    const data = JSON.parse(rawText)

    if (Array.isArray(data)) {
      for (const item of data) {
        const name: string | undefined = item?.ObjectName || item?.Objectname || item?.Name || item?.name || item?.Guid || item?.guid
        if (!name) continue

        const itemPath: string = item?.Path || item?.path || normalizedPath
        const cleanedPath = normalizePath(itemPath)
        entries.push({
          name,
          fullPath: buildFullPath(cleanedPath, name),
        })
      }
    }

    if (entries.length > 0) {
      return entries
    }
  } catch (error) {
    console.warn(`[listFolder] Non-JSON response for ${normalizedPath}:`, error)
  }

  // Fallback for plain-text directory listings
  return rawText
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((name) => ({
      name,
      fullPath: buildFullPath(normalizedPath, name),
    }))
}
